/**
 * Fundal colorat pentru tipul de plată (folosit în carduri)
 */
export const getPaymentBg = (tip_plata: string) => {
  switch ((tip_plata || '').toLowerCase()) {
    case 'card':
      return 'bg-blue-50 border-blue-300';
    case 'cash':
      return 'bg-green-50 border-green-300';
    default:
      return 'bg-gray-50 border-gray-200';
  }
};